import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { companyBySlugQueryOptions } from '@/entities/company'
import { Breadcrumb, type Crumb } from '@/shared/ui/breadcrumb'
import { INVOICE_TABS, InvoicePageView } from '../-ui/invoice-page'

// Прямой счёт компании (project_id null) — вне контура проекта.
const InvoiceSearchSchema = z.object({
  tab: z.enum(INVOICE_TABS).optional().catch(undefined),
})

export const Route = createFileRoute('/_app/companies/$company_/invoices/$invoice')({
  validateSearch: (search) => InvoiceSearchSchema.parse(search),
  head: () => ({ meta: [{ title: 'Счёт · STIT Deal' }] }),
  component: CompanyInvoicePage,
})

function CompanyInvoicePage() {
  const { company, invoice: invoiceId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  const companyQ = useQuery(companyBySlugQueryOptions(company))
  const c = companyQ.data

  return (
    <InvoicePageView
      invoiceId={invoiceId}
      activeTab={tab ?? 'comments'}
      onTabChange={(value) => void navigate({ search: { tab: value } })}
      docLink={(docId) => ({
        to: '/companies/$company/documents/$doc',
        params: { company, doc: docId },
      })}
      onDeleted={() =>
        void navigate({
          to: '/companies/$company',
          params: { company },
          search: { tab: 'invoices' },
        })
      }
      renderBreadcrumb={(inv) => (
        <Breadcrumb
          items={
            [
              { label: c?.name ?? company, to: '/companies/$company', params: { company } },
              {
                label: 'Счета',
                to: '/companies/$company',
                params: { company },
                search: { tab: 'invoices' },
              },
              { label: inv.number },
            ] satisfies Crumb[]
          }
        />
      )}
    />
  )
}
